export function formatDate(date) {
    let d = new Date(date);
    let df = ['Domenica', 'Lunedi', 'Martedi', 'Mercoledi', 'Giovedi', 'Venerdi', 'Sabato'][d.getDay()];
    df += ", " + d.getDate() + " ";
    df += ["Gennaio", "Febbraio",
        "Marzo", "Aprile", "Maggio",
        "Giugno", "Luglio", "Agosto",
        "Settembre", "Ottobre", "Novembre",
        "Dicembre"][d.getMonth()];
    return df;
}

export function diff_minutes(dt2, dt1) 
{
    let diff =(dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
}

export function formatDateDocumento(date) {
    if (typeof date == "string") {
        let [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    return `${padStart(date.getDate())}/${padStart(date.getMonth() + 1)}/${date.getFullYear()}`;
}

export function formatDateRitiro(date_string) {
    let d = new Date(date_string);
    let df = ['Domenica', 'Lunedi', 'Martedi', 'Mercoledi', 'Giovedi', 'Venerdi', 'Sabato'][d.getDay()];
    df += ", " + d.getDate() + " ";
    df += ["Gennaio", "Febbraio",
        "Marzo", "Aprile", "Maggio",
        "Giugno", "Luglio", "Agosto",
        "Settembre", "Ottobre", "Novembre",
        "Dicembre"][d.getMonth()];
    return df + ` - ${padStart(d.getHours())}:${padStart(d.getMinutes())}`;
}

function padStart(v) {
    return String(v).padStart(2, '0');
}

export function convertDateRitiroForDocumento(date_string) {
    let d = new Date(date_string);
    return `${d.getFullYear()}-${padStart(d.getMonth() + 1)}-${padStart(d.getDate())}T${padStart(d.getHours())}:${padStart(d.getMinutes())}:00`
}

export function dataConsegnaDocumentoToISOString(date_string) {
    let [d,m,y] = date_string.split('/');
    m = Number(m) - 1;
    return new Date(y, m, d);
}

export function localISOTime(date) {
    var tzoffset = date.getTimezoneOffset() * 60000;
    var localISOTime = (new Date(date - tzoffset)).toISOString().slice(0, 19);
    return localISOTime;
}

export function formattedCreateDate(dateStr) {
    let [date, time] = dateStr.split('T');
    let [y, m, d] = date.split('-');
    let [h, min] = time.split(':');
    return `${d}/${m}/${y} ${h}:${min}`;
}